import { firebaseEnv } from "../config/env";

export function publicProfileUrl(username: string): string {
  const project = firebaseEnv.projectId;
  if (!project || !username.trim()) return "";
  // Native WebViews use localhost; public links must use the matching Web environment.
  const url = new URL(`https://${project}.web.app/`);
  url.searchParams.set("profile", username.trim());
  return url.toString();
}
